import * as t from 'io-ts';
import { fromNullable } from 'io-ts-types/lib/fromNullable';
import { UrlFromString, DateFromUnknown, ArrayUpsertedEmpty } from './util';
function arrayOrOneOf(literalStrings) {
    const [one, two, ...r] = literalStrings;
    if (!one) {
        throw 'Never use arrayOrOneOf with zero options!';
    }
    if (!two) {
        const onlyOption = t.literal(one);
        return t.union([onlyOption, t.array(onlyOption)]);
    }
    const literals = t.union([t.literal(one), t.literal(two), ...r.map((e) => t.literal(e))]);
    return t.union([t.array(literals), literals]);
}
export const ContextUpsert = {
    '@context': fromNullable(t.literal('https://w3id.org/docmaps/context.jsonld'), 'https://w3id.org/docmaps/context.jsonld'),
};
export const OnlineAccount = t.intersection([
    t.type({
        id: t.string,
    }),
    t.partial({
        service: UrlFromString,
    }),
]);
export const Publisher = t.intersection([
    t.type({}),
    t.partial({
        id: t.string,
        logo: UrlFromString,
        name: t.string,
        homepage: UrlFromString,
        url: UrlFromString,
        account: OnlineAccount,
    }),
]);
export const Manifestation = t.intersection([
    t.type({
        type: arrayOrOneOf([
            'web-page',
            'web-content',
        ]),
    }),
    t.partial({
        id: t.string,
        service: UrlFromString,
        url: UrlFromString,
    }),
]);
export const Actor = t.union([
    t.type({
        type: arrayOrOneOf(['person']),
        name: t.string,
    }),
    t.unknown,
]);
export const RoleInTime = t.intersection([
    t.type({
        actor: Actor,
        role: t.string,
    }),
    t.partial({
        id: t.string,
        type: t.union([t.literal('pro:roleintime'), t.literal('pro:RoleInTime')]),
    }),
]);
export const ThingType = arrayOrOneOf([
    'review',
    'preprint',
    'evaluation-summary',
    'review',
    'review-article',
    'journal-article',
    'editorial',
    'comment',
    'reply',
]);
export const Thing = t.intersection([
    t.type({}),
    t.partial({
        published: DateFromUnknown,
        id: t.string,
        doi: t.string,
        type: ThingType,
        url: UrlFromString,
        content: t.array(Manifestation),
    }),
]);
export const Action = t.intersection([
    t.type({
        outputs: ArrayUpsertedEmpty(Thing),
        inputs: ArrayUpsertedEmpty(Thing),
        participants: ArrayUpsertedEmpty(RoleInTime),
    }),
    t.partial({
        id: t.string,
    }),
]);
const Status = t.string;
export const Assertion = t.intersection([
    t.type({
        item: t.unknown,
        status: Status,
    }),
    t.partial({
        happened: DateFromUnknown,
    }),
]);
export const Step = t.intersection([
    t.type({
        actions: ArrayUpsertedEmpty(Action),
        assertions: ArrayUpsertedEmpty(Assertion),
    }),
    t.partial({
        inputs: ArrayUpsertedEmpty(Thing),
        id: t.string,
        'next-step': t.union([t.string, t.null]),
        'previous-step': t.union([t.string, t.null]),
    }),
]);
export const Docmap = t.intersection([
    t.type({
        ...ContextUpsert,
        id: t.string,
        type: arrayOrOneOf(['docmap', 'Docmap', 'https://w3id.org/docmaps/v0/Docmap']),
        publisher: Publisher,
        created: DateFromUnknown,
    }),
    t.partial({
        steps: t.record(t.string, Step),
        'first-step': t.string,
        updated: DateFromUnknown,
    }),
]);
export const DocmapsFactory = {
    'web-page': Manifestation,
    docmap: Docmap,
    'https://w3id.org/docmaps/v0/Docmap': Docmap,
    Docmap: Docmap,
};
//# sourceMappingURL=types.js.map